import * as SecureStore from "expo-secure-store";

import type { LoginCredentials } from "@/schemas/auth/login";

export async function getLoginCredentialsFromStorage(): Promise<LoginCredentials | null> {
  const credsString = await SecureStore.getItemAsync("credentials");
  if (credsString === null || credsString === "") {
    return null;
  }
  const creds: LoginCredentials = JSON.parse(credsString);
  return creds;
}

export async function setLoginCredentialsInStorage(
  creds: LoginCredentials,
): Promise<void> {
  await SecureStore.setItemAsync("credentials", JSON.stringify(creds));
}

export async function clearLoginCredentialsFromStorage(): Promise<void> {
  await SecureStore.setItemAsync("credentials", "");
}
